export default {
    baseUrl: 'https://www.qyoucheng.com',
    assetsUrl: 'https://www.qyoucheng.com/ycimages/',
    "android": require('./assets/android.png'),
    "ios": require('./assets/ios.png'),
    "wxfw": require('./assets/wxgzh.jpg'),
    "copyright": "©2024 东莞市澳信网络服务有限公司版权所有 粤ICP备20003868号",
    "mail": "aoxinyoucheng@outlook.com",
    "worktime": " 周一至周五 9:00-17:00",
    "xieyi_doc": "https://www.qyoucheng.com/ycimages/assets/img/用户服务协议（有诚）.doc",
}